/**
 * SSR-safe locale reader.
 *
 * Public services historically used `localStorage.getItem("language") || "vi"`
 * as a fallback when the caller didn't pass a locale. That throws silently
 * on the server (localStorage is undefined) and causes hidden hydration
 * mismatches when the server renders "vi" but the client sees a different
 * saved preference.
 *
 * Preferred flow: pass `locale` from the page params / request context.
 * This helper only covers the legacy fallback path.
 */

export const DEFAULT_LOCALE = "vi"

export const safeReadLocale = (override?: string | null): string => {
  if (override) return override
  if (typeof window === "undefined") return DEFAULT_LOCALE
  try {
    return localStorage.getItem("language") || DEFAULT_LOCALE
  } catch {
    return DEFAULT_LOCALE
  }
}
